<template>
  <div class="claim__documents">
    <div class="messages__document" v-if="documentFiles.length > 0">
      <div class="message">
        <h2 class="title--m">{{getUiString(['claim_details', 'details', 'receipts', 'receipt_processed_title'])}}</h2>
      </div>
    </div>
    <div class="fileview fileview--receipts" v-if="documentFiles.length > 0">
      <LennocFileRow
        :fileRow="documentFiles"
        :fileKind="'receipts'"
        :isReadOnly="isClaimClosed"
        @deletedFile="deleteFile" />
    </div>
    <LennocSpinner v-if="busy" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ClaimFileReceipts',
  data () {
    return {
      busy: false,
      rootDocument: null
    }
  },
  props: {
    documentId: {
      type: String,
      default () {
        return ''
      }
    },
    isClaimClosed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      isEditable: 'claim/isEditableByMe',
      getClaimId: 'claim/claimId',
      getDocumentById: 'claim/getDocumentById',
      getUiString: 'uistrings/getUiString',
      getChecklistTypes: 'uistrings/checklistTypes',
      getReceipts: 'claim/getReceipts'
    }),
    documentFiles () {
      return this.getReceipts
    }
  },
  methods: {
    async deleteFile (fileId) {
      this.busy = true
      await this.$store.dispatch('claim/deleteReceipt', {
        documentId: fileId,
        claimId: this.getClaimId
      })
      await this.$store.dispatch('claim/refreshClaim')
      this.busy = false
    }
  },
  mounted () {
    if (this.documentId) {
      this.rootDocument = this.getDocumentById(this.documentId)
    }
  }
}
</script>
